<template>
    <div>
        <div class="search-bar">
            <div class="search-icon">
                <i class="material-icons">search</i>
            </div>
            <input type="text" placeholder="START TYPING...">
            <div class="close-search">
                <i class="material-icons">close</i>
            </div>
        </div>

        <nav class="navbar">
            <div class="container-fluid">
                <div class="navbar-header">
                    <a href="javascript:void(0);" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false"></a>
                    <a href="javascript:void(0);" class="bars"></a>
                    <a class="navbar-brand" href="index.html">ADMIN - DAPENBI</a>
                </div>
                <div class="collapse navbar-collapse" id="navbar-collapse">
                    <ul class="nav navbar-nav navbar-right">
                        <li class="pull-right"><a @click="signOut" href="javascript:void(0);" class="js-right-sidebar" data-close="true">Sign Out</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
  export default {
    name: 'Header',
    methods: {
      signOut () {
        console.log('logout')
        localStorage.removeItem('_token')
        location.reload()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Header.vue